import type { SiteName } from '@/scopes/common/domain/types'
import { buildBookingUrl } from '@/scopes/account/common/policies/bookingUrl'

interface GetRebookedBookingUrlParams {
  siteName: SiteName
  bookingNumber: string
  isGroupBooking: boolean
}

export function getRebookedBookingUrl({
  siteName,
  bookingNumber,
  isGroupBooking,
}: GetRebookedBookingUrlParams): string | undefined {
  return buildBookingUrl(siteName, bookingNumber, !isGroupBooking)
}
